import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '../shared/button/button.component';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { consultingItem, navigationItems } from '../../constants/navigation';
import { EmailService } from '../../services/email.service';

@Component({
    selector: 'app-footer',
    imports: [CommonModule, RouterModule, ButtonComponent, MatInputModule, ReactiveFormsModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

  public currentYear = new Date().getFullYear();
  public newsletterEmail = new FormControl('', [Validators.required, Validators.email]);
  public navItems = [
    ...navigationItems, {
      title: 'Our Commitment',
      nav: 'commitment'
    }, {
      title: 'Career',
      nav: 'career'
    }
  ];
  public serviceItems = consultingItem;

  constructor(private emailService: EmailService) {}

  subscriptionMessage: string | null = null;

  onSubscribe() {
    if (!this.newsletterEmail.valid) {return};
    const params = {
      subject: 'Newsletter subscription for ' + this.newsletterEmail.value,
      content: this.newsletterEmail.value + ' has subscribed to the newsletter from the new RA website',
      to: 'contact@reliefapplications.org'
    };
    
    this.emailService.sendEmail(params, (err, data) => {
      if (err) {
        window.alert('There was an error subscribing to the newsletter, please try again');
      }
      else {
        this.subscriptionMessage = 'You are now subscribed!';
        setTimeout(() => {this.subscriptionMessage = null;}, 5000);
      }
    });
  }

}
